import AppHeader from '@components/AppNavigation/AppHeader';
import { Box, Grid, IconButton } from '@mui/material';
import { Stack } from '@mui/system';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import React, { FC, useState } from 'react';
import { IOIDCSettings, ISSOSettings, SSOTypes } from 'types/settings';
import { ExperimentId, isExperimentOpen } from 'experiments';
import OIDCSettings from './SSO/OIDCSettings/OIDCSettings';
import ProjectSSOPage from './SSO/ProjectSSOSetup';
import SSOCard from './SSO/SSOCard';

interface ISSOProps {
	saml?: ISSOSettings;
	oidc?: IOIDCSettings;
	onSPSave: (data: ISSOSettings) => Promise<ISSOSettings>;
	onOIDCSave: (data: IOIDCSettings) => Promise<IOIDCSettings>;
}

const SSOPage: FC<ISSOProps> = ({ onSPSave, onOIDCSave, saml, oidc }) => {
	const isSSOExtended = isExperimentOpen(ExperimentId.OIDC);
	const [selectedType, setSelectedType] = useState<SSOTypes | undefined>(
		!isSSOExtended ? SSOTypes.sp : undefined
	);

	let comp = (
		<Grid container flexGrow={1} flexDirection="row" alignContent="flex-start">
			<Grid container spacing={2} p={4}>
				<SSOCard title={SSOTypes.sp} onClick={setSelectedType} />
				<SSOCard title={SSOTypes.oidc} onClick={setSelectedType} />
			</Grid>
		</Grid>
	);

	switch (selectedType) {
		case SSOTypes.oidc:
			comp = <OIDCSettings settings={oidc} onSave={onOIDCSave} />;
			break;
		case SSOTypes.sp:
			comp = <ProjectSSOPage settings={saml} onSave={onSPSave} />;
			break;
		default:
			break;
	}

	return (
		<Box
			display="flex"
			flexDirection="column"
			flexGrow={1}
			overflow="hidden"
			data-testid="authentication-methods-sso"
		>
			<Stack direction="row" alignItems="center" ml={2} mt={2}>
				{isSSOExtended && selectedType && (
					<Box display="flex" alignItems="center">
						<IconButton
							color="primary"
							aria-label={intl.tr('button.back')}
							component="span"
							onClick={() => setSelectedType(undefined)}
							data-testid="sso-back-button"
						>
							<ArrowBackIcon />
						</IconButton>
					</Box>
				)}
				<AppHeader
					translation={
						selectedType
							? `pages.authMethods.sso.card.title.${selectedType}`
							: 'pages.authMethods.sso.title'
					}
					sx={{ m: 0 }}
				/>
			</Stack>
			{comp}
		</Box>
	);
};

SSOPage.defaultProps = {
	saml: undefined,
	oidc: undefined
};

export default SSOPage;
